import { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import Select from '../../../juristec-ui/core/SelectNew';
import ActionsGroup from '../../../juristec-ui/core/ActionsGroup';
import Button from '../../../juristec-ui/core/Button';

import { MainContainer, InfoText, WarningMessage } from './styled/TransferKpi.styled';

const transferKpiDefaultPropDashOptions = [];
const transferKpiDefaultPropClose = () => {};
const transferKpiDefaultPropSubmit = () => {};

/** Transfers all allowed data from one user to another */
const TransferKpi = ({
  currentKpis,
  dashOptions = transferKpiDefaultPropDashOptions,
  close = transferKpiDefaultPropClose,
  submit = transferKpiDefaultPropSubmit,
}) => {
  const [selected, setSelected] = useState([]);

  const handleSubmit = () => {
    submit(selected.map((s) => s.value));
  };

  return (
    <MainContainer>
      <InfoText>
        Selecione os dashboards para os quais você deseja transferir
        {currentKpis.length > 1 ? " as cópias dos KPI's " : ' a cópia o KPI '}
        {currentKpis.map((kpi, i) => (
          <Fragment key={kpi.id}>
            <b>
              {kpi.name}
            </b>
            {(currentKpis.length - 1) > i ? ', ' : ''}
          </Fragment>
        ))}
      </InfoText>
      <span style={{ fontSize: '10pt', marginBottom: '10px' }}>
        <WarningMessage>
          <strong>Atenção: </strong>
        </WarningMessage>
        Se os dashboards de destino estiverem compartilhados com outros usuários, estes
        terão acesso aos arquivos utilizados em sua construção.
      </span>
      <Select
        label="Dashboards de destino"
        value={selected}
        onChange={setSelected}
        options={dashOptions}
        atModal
        stayOpen
        searchable
        clearable
        sortBy="ascending"
        multiple
      />
      <ActionsGroup>
        <Button
          style={{ margin: '5px' }}
          onClick={close}
          variant="outlined"
          size="large"
        >
          Cancelar
        </Button>
        <Button
          style={{ margin: '5px' }}
          onClick={handleSubmit}
          size="large"
          disabled={selected.length === 0}
        >
          Transferir
        </Button>
      </ActionsGroup>
    </MainContainer>
  );
};

TransferKpi.propTypes = {
  currentKpis: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
  })).isRequired,
  dashOptions: PropTypes.arrayOf(PropTypes.shape({})),
  close: PropTypes.func,
  submit: PropTypes.func,
};

export default TransferKpi;
